import React from 'react';
import './ButtonLoader.css';

const ButtonLoader = () => {
    return (
        <React.Fragment>
            <div class="spinner"></div>
        </React.Fragment>
    )
}

export default ButtonLoader